import * as React from "react";
import Page, { PageProps } from "../Page";
import { IFormsPresenter } from "../../../presenter/form/FormsPresenter";
import DataGrid from "../../components/app/grid/DataGrid";
import ReportingPeriodRowExpanded from "../../components/form/ReportingPeriodRowExpanded";
import { Spin } from "antd";
import Loader from "../../components/Loader";

export interface Props extends PageProps {}
export interface State extends IFormsPresenter {}

export default class FormsPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      reportingPeriods,
      formTypes,
      onReportingPeriodRowExpanded,
      isPreviousForms,
      addNewDraftFormVersion,
      loaders
    } = this.state;

    const columns = [
      {
        title: translate(
          "reports_page.reporting_periods_datagrid.columns.name"
        ),
        dataIndex: "name",
        key: "name"
      },
      {
        title: translate(
          "reports_page.reporting_periods_datagrid.columns.period_from"
        ),
        dataIndex: "periodFrom",
        key: "periodFrom",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.periodFrom, b.periodFrom)
      },
      {
        title: translate(
          "reports_page.reporting_periods_datagrid.columns.period_to"
        ),
        dataIndex: "periodTo",
        key: "periodTo",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.periodTo, b.periodTo)
      },
      {
        title: translate(
          "reports_page.reporting_periods_datagrid.columns.input_available_from"
        ),
        dataIndex: "inputAvailableFrom",
        key: "inputAvailableFrom",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(
            a.inputAvailableFrom,
            b.inputAvailableFrom
          )
      },
      {
        title: translate(
          "reports_page.reporting_periods_datagrid.columns.input_available_to"
        ),
        dataIndex: "inputAvailableTo",
        key: "inputAvailableTo",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(
            a.inputAvailableTo,
            b.inputAvailableTo
          )
      }
    ];

    const reportingPeriodRowExpanded = (e) => {
      const reportingPeriodRow = (
        <ReportingPeriodRowExpanded
          translate={translate}
          formTypes={formTypes}
          rowData={e}
          isPreviousForms={isPreviousForms}
          addNewDraftFormVersion={addNewDraftFormVersion}
        />
      );
      return (
        <Loader
          children={reportingPeriodRow}
          loading={this.state.loaders.formTypesLoader}
          translate={translate}
        />
      );
    };

    return (
      <Page {...this.props}>
        <Loader
          loading={loaders.formNewVersionLoader}
          tip={translate("form_details.new_draft_version_loading")}
          translate={translate}
          size="large"
        >
          {this.state.loaders.formsLoader ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Spin tip={this.props.translate("loading")} />
            </div>
          ) : (
            <DataGrid
              title={
                isPreviousForms
                  ? translate("grids.previous-forms")
                  : translate("grids.forms")
              }
              translate={translate}
              columns={columns}
              dataSource={reportingPeriods ? reportingPeriods : []}
              allowCreate={false}
              allowDelete={false}
              allowUpdate={false}
              singleRowExpandEnabled={true}
              expandedRowRender={reportingPeriodRowExpanded}
              onExpand={onReportingPeriodRowExpanded}
            />
          )}
        </Loader>
      </Page>
    );
  }
}
